import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import { Button, IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { useTranslation } from 'react-i18next';
import  LightTooltip  from '../../commonComponents/LightTooltip';
export const getAllParentNode = (translatedData)=>{
    const parentNodes = {};
   eachDeep(translatedData,(obj)=>{
    if(obj?.key && obj?.children?.length){
      if(parentNodes.hasOwnProperty(obj.nodeId))
        parentNodes[`${obj.nodeId}_1`] = obj?.key;
      else
        parentNodes[obj.nodeId] = obj?.key;
    }
   })
   return parentNodes;
}

function ExpandCollapse({setExpandActions}) {
    const { t } = useTranslation()
    const parentScreen = useContext(ParentScreenCtx);
    const selectedNode = useSelector(
        (state) =>
            state.treeData[parentScreen].leftTree.tree.body
                .selectedNode
    );
    const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree?.currentTab;
    const translatedData = rightTree?.tree[rightTree?.currentTab]?.translatedData;

    const handleExpand = () => {
        const parentNodeArray = getAllParentNode (translatedData)
        setExpandActions({tab:currentTab,keys:parentNodeArray});
    } 

    const hendleCollapse = () => {
        setExpandActions({tab:currentTab,keys:[]});
    }

    return (
      <>
        <LightTooltip title={t('BTN_EXPAND_ALL_ITEMS')}>
          <span>
            <IconButton
              variant="outlined"
              onClick={handleExpand}
              sx={{
                height: "32px !important", 
                minHeight: "32px !important", 
                width: "32px !important", 
                minWidth: "32px !important", 
                borderRadius: "0 !important",
              }}
              disabled={
                !selectedNode?.type || selectedNode?.type === "workflowGroup"
              }>
              <KeyboardDoubleArrowDownIcon
                fontSize="medium"
              />
            </IconButton>
          </span>
        </LightTooltip>
        <LightTooltip title={t('BTN_COLLAPSE_ALL_ITEMS')}>
          <span>
            <IconButton
              variant="outlined"
              className="margin-right-4"
              onClick={hendleCollapse}
              sx={{
                height: "32px !important", 
                minHeight: "32px !important", 
                width: "32px !important", 
                minWidth: "32px !important", 
                borderRadius: "0 !important",
              }}
              disabled={
                !selectedNode?.type || selectedNode?.type === "workflowGroup"
              }>
              <KeyboardDoubleArrowUpIcon
                fontSize="medium"
              />
            </IconButton>
          </span>
        </LightTooltip>
      </>
    );
}

export default ExpandCollapse
